import { Outlet, createFileRoute } from '@tanstack/react-router';

import { SalesNotificationBanner } from '@/features/stripe-connect';
import { useIdleReturnBuildRefresh } from '@/lib/use-unsaved-work-guard';

/**
 * Sales section layout. Surfaces the embedded Stripe notification banner (shown
 * only when a controller account has outstanding requirements) above the
 * section content.
 */
export const Route = createFileRoute('/_authed/dashboard/l/$locationId/sales')({
  component: SalesLayout,
});

function SalesLayout() {
  // The till: open all day, rarely changes page. Checkout holds the refresh
  // itself while a sale is in progress.
  useIdleReturnBuildRefresh();
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <SalesNotificationBanner />
      <Outlet />
    </div>
  );
}
